import { render, staticRenderFns } from "./IntegratedModelShare.vue?vue&type=template&id=24abd882&scoped=true"
import script from "./IntegratedModelShare.vue?vue&type=script&lang=js"
export * from "./IntegratedModelShare.vue?vue&type=script&lang=js"
import style0 from "./IntegratedModelShare.vue?vue&type=style&index=0&id=24abd882&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24abd882",
  null
  
)

export default component.exports